import { objectSchemaOf, Joi, actionCreator } from '../helpers';
import { INVITATIONS_INPUT } from './topics';

export const CHECK_IN = 'INVITATIONS/CHECK_IN' as const;

export interface ICheckInPayload {
  invitationId: string;
  conversationId: string;
  checkInTime: number;
}

export interface ICheckInAction {
  type: typeof CHECK_IN;
  payload: ICheckInPayload;
}

export const checkInActionSchema = objectSchemaOf<ICheckInAction>({
  type: Joi.string().required().valid(CHECK_IN),
  payload: objectSchemaOf<ICheckInPayload>({
    invitationId: Joi.string().required(),
    conversationId: Joi.string().required(),
    checkInTime: Joi.number().required(),
  }).required(),
});

export const checkIn = actionCreator({
  type: CHECK_IN,
  topic: INVITATIONS_INPUT,
  schema: checkInActionSchema,
});
